import { useEffect, useState } from "react";
import { _Inbox, _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../theme/Component/PrintJson";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOP008 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_SupplierPaymentOrder);
    const [props, setProps] = useState<any>({})

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])


    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(bean.Obs)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean)
        }
    }

    const handleSendAccount = () => {
        if (bean.Obs.length > 15) {
            sendSupplierPaymentOrderToAccounting()
        } else {
            toast.error("La justificación debe tener minimo 15 caracteres")
        }
    }

    const handleSendToStore = () => {
        if (bean.Obs.length > 15) {
            sendSupplierPaymentOrderToStore()
        } else {
            toast.error("La justificación debe tener minimo 15 caracteres");
        }
    }

    const sendSupplierPaymentOrderToAccounting = () => {
        instance.sendSupplierPaymentOrderToAccounting(props.IDSupplierPaymentOrder, props.SupplierPaymentOrderDate, bean.Obs, _single.getAccountID()).then(
            (resp: any) => {
                toast.success("Factura enviada a contabilización");
                onExportMap()
            }
        ).catch(err => toast.error(err));
    }

    const sendSupplierPaymentOrderToStore = () => {
        instance.sendSupplierPaymentOrderToStore(props.IDSupplierPaymentOrder, props.SupplierPaymentOrderDate, bean.Obs, _single.getAccountID()).then(
            (resp: any) => {
                toast.success("Factura enviada a Almacen");
                onExportMap()
            }
        ).catch(err => toast.error(err));

    }

    return (
        <div className="row d-flex justify-content-between">
            <div className="col-md-12 mb-2">
                <label>Observaciones</label>
                <textarea className="form-control" value={bean.Obs} onChange={(e) => { setBean({ ...bean, "Obs": e.target.value }) }} />
            </div>
            <div className="col-md-4">
                <BasicButton icon="ri-checkbox-circle-line" eventClick={() => { handleSendToStore() }} >Enviar a Almacen</BasicButton>
            </div>
            <div className="col-md-4 d-flex justify-content-end">
                <BasicButton icon="ri-close-circle-line" eventClick={() => { handleSendAccount() }} >Enviar a Contabilizar</BasicButton>
            </div>
        </div>
    );
}